import Rules from '@/services/validation/rules/rules'
export default {
  data() {
    return {
      nameRules: [
        v => Rules.isRequired(v),
        v => Rules.minLength(v, 1),
        v => Rules.maxLength(v, 90)
      ],
      numberRules: [
        v => Rules.minLength(v, 1),
        v => Rules.maxLength(v, 20)
      ],
      contactEmailRules: [
        v => Rules.isEmail(v)
      ],
      detailsRules: [
        v => Rules.minLength(v, 1),
        v => Rules.maxLength(v, 100)
      ]
    }
  }
}

